import { MetricConverter } from './helpers';

const I2tUnits = ['A²•s', 'kA²•s', 'MA²•s'] as const;
type TI2tUnit = (typeof I2tUnits)[number];

class I2tConverter extends MetricConverter<TI2tUnit, 'A²•s'> {
    baseUnit = 'A²•s' as const;
    units = I2tUnits;
}

export const i2tConverter = new I2tConverter();
